export const PROJECT_TYPES = {
  minfin: 'minfin',
  finance: 'finance',
  multi: 'multi',
};

export const PROJECTS_CONFIG = {
  [PROJECT_TYPES.minfin]: {
    name: 'Minfin.com.ua',
    phone: '050 020-63-18',
  },
  [PROJECT_TYPES.finance]: { name: 'Finance.ua', phone: '0 800 307 555' },
  [PROJECT_TYPES.multi]: { name: 'MULTI', phone: '0 800 307 555' },
};
